import React from 'react'
import { Button } from 'react-bootstrap'
import { handleJobCostingFormCreateAndUpdate } from '../commonHandlerFunction/Audit/JobCosting/JobCostingHandlerFunction'
import { useNavigate } from 'react-router-dom'
import { encryptDataForURL } from '../../../utills/useCryptoUtils'

const JobCostingButton = ({
  status,
  formData,
  formConfig,
  setFormData,
  EditRecordId,
  setIsOverlayLoader,
  viewOnly,
  user,
  handleSubmit,
  setIsRejectPopupOpen
}) => {

  const navigate = useNavigate()
  const currentStatus = formData[0]?.jc_status;
  const loggedInUserId = user?.logged_in_user_info?.usr_id;
  const approvalUserId = formData[0]?.fk_approval_id;

  return (
    <div className="auditBtns">
      {/* Cancel Button - Always Visible */}
      <Button
        type="button"
        className="cancelBtn"
        onClick={() => {
          setFormData([]);
          navigate("/audit/job-costing-list");
        }}
      >
        Cancel
      </Button>


      {!viewOnly && (
        <>

          {['updated', 'rejected'].includes(currentStatus) && (
            <>
              {['updated'].includes(currentStatus) && <Button
                type="button"
                className="saveBtn"
                onClick={() =>
                  handleJobCostingFormCreateAndUpdate(
                    setFormData,
                    EditRecordId,
                    formData,
                    formConfig,
                    navigate,
                    "saved",
                    viewOnly,
                    null
                  )
                }
              >
                Save
              </Button>}

              <Button
                type="button"
                className="submitBtn"
                onClick={() => {
                  let isValidate = handleSubmit();
                  if (!isValidate) {
                    return false;
                  }
                  handleJobCostingFormCreateAndUpdate(
                    setFormData,
                    EditRecordId,
                    formData,
                    formConfig,
                    navigate,
                    "sent_for_approval",
                    viewOnly,
                    null
                  )
                }

                }
              >
                Post
              </Button>
            </>
          )}
          {currentStatus === "saved" && (
            <>
              <Button
                type="button"
                className="saveBtn"
                onClick={() =>
                  handleJobCostingFormCreateAndUpdate(
                    setFormData,
                    EditRecordId,
                    formData,
                    formConfig,
                    navigate,
                    "saved",
                    viewOnly,
                    null
                  )
                }
              >
                Save
              </Button>
              <Button
                type="button"
                className="submitBtn"
                onClick={() => {
                  let isValidate = handleSubmit();
                  if (!isValidate) {
                    return false;
                  }
                  handleJobCostingFormCreateAndUpdate(
                    setFormData,
                    EditRecordId,
                    formData,
                    formConfig,
                    navigate,
                    "sent_for_approval",
                    viewOnly,
                    null
                  )
                }
                }
              >
                Post
              </Button>
            </>
          )}

          {/* Send for Approval - visible when status is "posted" */}
          {currentStatus === "posted" && (
            <Button
              type="button"
              className="submitBtn"
              onClick={() =>
                handleJobCostingFormCreateAndUpdate(
                  setFormData,
                  EditRecordId,
                  formData,
                  formConfig,
                  navigate,
                  "sent_for_approval",
                  viewOnly,
                  null
                )
              }
            >
              Send for Approval
            </Button>
          )}

          {/* Approve - visible when status is "sent_for_approval" and logged-in user is the approver */}
          {currentStatus === "sent_for_approval" && (
            <>
              <Button
                type="button"
                className="submitBtn"
                onClick={(e) => setIsRejectPopupOpen(true)}
              >
                Reject
              </Button>
              <Button
                type="button"
                className="submitBtn"
                onClick={() =>
                  handleJobCostingFormCreateAndUpdate(
                    setFormData,
                    EditRecordId,
                    formData,
                    formConfig,
                    navigate,
                    "approved",
                    viewOnly,
                    null
                  )
                }
              >
                Approve
              </Button>

            </>
          )}

          {formData[0]?.fk_im_id?.im_invoiceurl && <Button
            type="button"
            className="submitBtn"
            href={`/#/operation/invoice-listing/invoice-preview/${encryptDataForURL(
              formData[0]?.fk_im_id?.im_id
            )}/${encryptDataForURL(
              formData[0]?.fk_im_id?.im_invoiceurl
            )}/${encryptDataForURL(
              formData[0]?.fk_im_id?.im_invoiceurl
            )}`}
            as="a"
            target="_blank"
            rel="noopener noreferrer"
          >
            Preview
          </Button>}
        </>
      )}
    </div>
  );


}

export default JobCostingButton